export enum PermissionPush {
  GRANTED = 'granted',
  DENIED = 'denied',
  PROMPT = 'prompt' // ios only. 아직 푸시 권한 요청을 한번도 안한 경우
}

export enum PermissionStatusRecorded {
  YES = 'yes',
  NO = 'no'
}

export enum PermissionsType {
  CONTACT = 'permission_asked_contact', // 연락처 권한 허용 dialog 띄워졌는지 여부 (최초 한 번만 띄울 수 있음)
  PUSH = 'permission_asked_push',
  PUSH_AFTER_LOGIN = 'permission_asked_push_after_login', // login 이후 main페이지에서 푸시 권한 요청 모달 최초 1회만 띄워주기
  IOS_IDFA_TRACKER = 'permission_asked_ios_idfa_tracker' // ios only - 핸드폰 정보 추척 허용 요청 모달
}